
























































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { InfoState } from '@/core';
// import { MswApiService } from '@/shared/msw-api-service';
import { SwTable, TableEntry, TableColumnConfig, SortedColumnInfo, ColumnSortRequestData } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwExpandableTextfield, SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { MswApiService } from '../../shared/msw-api-service';
import { CreateElement, VNode } from 'vue';
import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import { MswAppTitle }  from '@/shared/msw-app-title';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';

const cssPrefix = 'snbApplicablePromotions';

@Component({
  components: {
    ...UUIFComponent,
    SwDropMenu,
    SwIconButton,
    SwExpandableTextfield,
    SwTextfield,
    SwTable,
    SwModal,
    SwModalBody,
    SwModalFooter,
    MswAppTitle,
  },
  directives: {},
})

export default class SandboxApplicablePromotions extends SwExtendedVue {
  cssPrefix = cssPrefix;
  tableData: TableEntry[] = [];
  tempTableData: TableEntry[] = [];
  filtered: TableEntry[] = [];
  tableConfig: TableColumnConfig[] = [];
  menuOpened: boolean = false;
  apiResponse: any = '';
  filterItems: DropMenuItem[] = [];
  selectedMenuItem: string = '';
  searchValue: any = '';
  search: any = '';
  textExpanded : boolean = false;
  picked: string = '';
  openModal: boolean = false;
  selectedTableEntry: any = '';
  sortedColumns: SortedColumnInfo[] = [];

  expandVisible : boolean = false;
  globalSearchValue : string = '';
  columnSearchValue : string = '';
  searchInputChips: any[] = [];
  filterSearchConfig: any = {
    isEnableFilterSearch: false,
    filterSearchKey:'',
    filterSearchOption:'',
    filterSearchLabel:'',
  };
  filterColumnKey: string = '';
  filterColumnValue: string = '';

  // @Watch('search')
  // whenSearchEmpty() {
  //   if (this.search === '') {
  //     this.filtered = this.tableData;
  //   }
  // }

  get tableHeight() {
    return 'calc(100vh - 320px)';
  }

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  getAplicablePromotions() {
    this.$store.commit('startLoading');
    MswApiService.promotions.getApplicablePromotions()
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'NOK') {
        return this.showMessage('failed', resp.msgDesc);
      }
      this.apiResponse = resp.content;
      this.makeTableHeaders();
      this.makeTableData();
      this.makeDropDownOptions();
    });
  }

  makeDropDownOptions() {
    const options = this.tableConfig.filter((each: any) => each.title.toLowerCase() !== 'action');
    this.filterItems = options.map((each: any) => {
      return {
        id: each.key,
        content: each.title,
      };
    });
  }

  makeTableHeaders() {
    const tableHeaders = [
      {
        key: 'serialNumber',
        dataKey: 'serialNumber',
        title: this.$t('myPromotions.trdUnit')
        .toString(),
        sorter: true,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.serialNumber;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                { data.entry.serialNumber }
                <div style="margin-left: 1rem;">
                  <span onClick={() => { this.onEdit(data.entry); }}>
                    <sw-icon name={'pencil'} size={'small'} v-tooltip={{ content: 'Edit' , compact: true }}></sw-icon>
                  </span>
                </div>
                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.serialNumber && (
                    <SwIcon
                      name="filter"
                      size={12}
                      style={{ marginLeft: '1rem' }}
                      v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.columnSearchValue = data.entry.serialNumber;
                        this.filterByEachRow('serialNumber');
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'upgradeUnit',
        dataKey: 'upgradeUnit',
        title: this.$t('myPromotions.upgrdUnit')
        .toString(),
        sorter: true,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          {
            return (
              <div
                style={{ display: 'flex', flex: '1', alignItems: 'center' }}
                on-mouseover={() => {
                  this.filterColumnKey = data.entry._key;
                  this.filterColumnValue = data.entry.upgradeUnit;
                }}
                on-mouseleave={() => (this.filterColumnKey = '')}
              >
                { data.entry.upgradeUnit }
                {this.filterColumnKey === data.entry._key &&
                  this.filterColumnValue === data.entry.upgradeUnit && (
                    <SwIcon
                      name="filter"
                      size={12}
                      style={{ marginLeft: '1rem' }}
                      v-tooltip={{ content: 'Add Filter', compact: true, placement: 'bottom' }}
                      nativeOn-click={() => {
                        this.columnSearchValue = data.entry.upgradeUnit;
                        this.filterByEachRow('upgradeUnit');
                      }}
                    ></SwIcon>
                  )}
              </div>
            ) as VNode;
          }
        },
      },
      {
        key: 'action',
        dataKey: 'action',
        title: this.$t('myPromotions.action')
        .toString(),
        sorter: true,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div>
              <span onClick={() => { this.onTransfer(data.entry); }}>
                <sw-icon
                  name={'topo-change'}
                  size={'medium'}
                  v-tooltip={
                  {
                    content: this.$t('profile.transfer')
                    .toString(),
                    compact: true,
                  }
                  }
                ></sw-icon>
              </span>
            </div>
          ) as VNode;
        },
      },
    ];
    this.tableConfig = tableHeaders;
  }

  makeTableData() {
    if (this.apiResponse.applyUpgradeDetials[0].serialNumber) {
      this.tableData = this.apiResponse.applyUpgradeDetials.map((el: any, index: any) => {
        return {
          _key: index,
          upgradeUnit: el.upgradeUnit,
          serialNumber: el.serialNumber,
          upgradeSerialNumber: el.upgradeSerialNumber,
        };
      });
    } else {
      this.tableData = [];
    }
    this.tempTableData = this.tableData;
  }

  onSelectMultiItem(type: any) {
    this.menuOpened = !this.menuOpened;
    this.globalSearchValue = '';
    const isExistingChip = this.searchInputChips?.find((el: any) => el.column === type);
    if (!isExistingChip) {
      this.filterSearchConfig.isEnableFilterSearch = true;
      this.filterSearchConfig.filterSearchOption = type;
      this.filterSearchConfig.filterSearchLabel = this.filterItems.filter(ele => ele.id.toString() === type)[0].content;
    }
  }

  filterByEachRow(type: any) {
    this.globalSearchValue = '';
    if (this.columnSearchValue) {
      const isExistingChip = this.searchInputChips?.find((el: any) => el.column === type);
      if (!isExistingChip) {
        this.searchInputChips.push({ value: this.columnSearchValue.trim(), column: type });
      }
      this.applyAllFilters();
    }
  }

  handleSearchFilter() {
    this.expandVisible = !this.expandVisible;
    this.applyAllFilters();
  }

  removeInputChip(index: any) {
    this.searchInputChips.splice(index, 1);
    this.applyAllFilters();
  }

  addFilterKey(event: any) {
    if (event.code === 'Enter' && this.filterSearchConfig.filterSearchKey !== '') {
      this.searchInputChips.push({ value: this.filterSearchConfig.filterSearchKey.trim(), column: this.filterSearchConfig.filterSearchOption });
      this.applyAllFilters();
      this.filterSearchConfig.filterSearchKey = '';
      this.filterSearchConfig.filterSearchLabel = '';
      this.filterSearchConfig.isEnableFilterSearch = false;
    }
  }

  applyAllFilters() {
    const data: any[] = [...this.tempTableData];
    let filteredData : any[] = [];
    this.$store.commit('startLoading');
    if (this.globalSearchValue) {
      this.filterItems.forEach((column: any) => {
        filteredData.push(...data.filter((element: any) => {
          return element[column.id].indexOf(this.globalSearchValue) > -1;
        }));
      });
    } else {
      if (this.searchInputChips.length === 0) {
        this.tableData = [...data];
        this.$store.commit('stopLoading');
        return;
      }
      filteredData = data.filter((item) => {
        for (const filter of this.searchInputChips) {
          if (item[filter.column] !== filter.value) {
            return false;
          }
        }
        return true;
      });
    }
    this.tableData = [...filteredData];
    this.$store.commit('stopLoading');
  }

  onRemoveAllFilters() {
    this.globalSearchValue = '';
    this.columnSearchValue = '';
    this.filterSearchConfig = {
      isEnableFilterSearch: false,
      filterSearchKey:'',
      filterSearchOption:'',
      filterSearchLabel:'',
    };
    this.searchInputChips = [];
    this.applyAllFilters();
  }
  // Filter Implementation ends

  reloadData() {
    this.onRemoveAllFilters();
    this.getAplicablePromotions();
  }

  showMessage(infoType: string, infoMsg: string) {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }

  onCancel() {
    this.openModal = false;
  }

  onConfirm() {
    console.warn(this.selectedTableEntry);
    if (this.picked === 'SonicReplacement') {
      this.$router.push({ path: 'applySecureUpgrade', query: {
        upgradeId: this.$route.query.data,
        srNo: this.selectedTableEntry.upgradeSerialNumber,
        fromSrNo: this.selectedTableEntry.serialNumber,
        snbuser: this.$route.query.snbuser,
      },
      });
    } else {
      this.$router.push({ path: 'competitiveTradeIn', query: {
        upgradeId: this.$route.query.data,
        srNo: this.selectedTableEntry.upgradeSerialNumber,
        fromSrNo: this.selectedTableEntry.serialNumber,
        snbuser: this.$route.query.snbuser,
      },
      });
    }
  }

  onEdit(item: any) {
    // console.warn(item);
    this.openModal = true;
    this.selectedTableEntry = item;
  }

  onTransfer(item: any) {
    this.selectedTableEntry = item;
    this.$router.push({ path: 'transfersecureupgrade', query: {
      to: this.selectedTableEntry.upgradeSerialNumber,
      frm: this.selectedTableEntry.serialNumber,
      snbuser: this.$route.query.snbuser,
      upgradeID: this.$route.query.data,
    },
    });
  }

  mounted() {
    this.getAplicablePromotions();
  }
}
